import React from 'react';
import PropTypes from 'prop-types';
import { Container, IconWrapper, Content } from './components/InfoBoxStyles';
import { useInfoBox } from './hooks/useInfoBox';
import { getInfoBoxIconClass } from './utils/infoBoxHelpers';

const InfoBox = ({ children, icon = 'fa fa-info-circle', onClick, ...rest }) => {
  const { handleClick } = useInfoBox({ onClick });
  const iconClass = getInfoBoxIconClass(icon);

  return (
    <Container onClick={handleClick} {...rest}>
      <IconWrapper>
        <i className={iconClass} />
      </IconWrapper>
      <Content>{children}</Content>
    </Container>
  );
};

InfoBox.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.string,
  onClick: PropTypes.func,
};

export default InfoBox;



// WEBPACK FOOTER //
// ./src/design-system/atoms/InfoBox/InfoBox.jsx